
<template>
<f7-page class="page" id="notification-page" name="notification-page" @page:beforeout="handleBeforeOut()" @page:afterin="afterin();" >
    <f7-navbar class="view-mobile no-border">
        <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block>
        <div class="col-70 text-align-left mb-20">
            <div class="wandr-title-1">{{$t('general-text-notification')}}</div>
        </div>

        <f7-list class="list-notif" v-show="notification.unreadInboxList.length > 0">
            <f7-list-item  v-for="item in notification.unreadInboxList" :key="item.id" @click="readInbox(item)">
                <div class="card card-notification ">
                    <div class="notification-subject b">{{item.subject}}</div>
                    <div class="card-content" v-html="item.content"></div>
                    <div class="card-footer">
						<div class="notification-date">{{item.date}}</div>
                        <a href="#" class="link"><i class="f7-icons">chevron_right</i> </a>
                    </div>
                </div>
            </f7-list-item>
        </f7-list>

        <div v-show="notification.unreadInboxList.length > 0 && notification.readInboxList.length > 0" class="text-line text-color-gray"> Seen </div>

        <f7-list class="list-notif" v-show="notification.readInboxList.length > 0">
            <f7-list-item v-for="item in notification.readInboxList" :key="item.id" @click="readInbox(item)">
                <div class="card card-notification seen">
                    <div class="notification-subject b">{{item.subject}}</div>
                    <div class="card-content" v-html="item.content"></div>

                    <div class="card-footer">
						<div class="notification-date">{{item.date}}</div>
                        <a href="#" class="link"><i class="f7-icons">chevron_right</i> </a>
                    </div>
                </div>
            </f7-list-item>
        </f7-list>

        <div class="preloader infinite-scroll-preloader" v-show="notification.showLoadingBar"></div>
    </f7-block>

    <f7-toolbar position="bottom" no-hairline class="toolbar-with-stacked-button view-mobile">
        <f7-button large fill @click="goHome()" :disabled="false">
            {{$t('general-text-back-to-home')}}
        </f7-button>
    </f7-toolbar>
</f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex"
    export default {
        mounted (){
            const self = this;

            // Required for everypage. Toggle desktop-view footer.
            this.toggleFooterVisibility(false)

            self.launchNotification()

            this.$f7.$('.page-content').on('scroll', (e) => {
                let treshold =20
                let bottomOfWindow = e.target.scrollTop + e.target.clientHeight+treshold >= e.target.scrollHeight;
                if(self.hasMoreItems&& bottomOfWindow ){
                    self.setNotifShowLoadingBar(true);
                    self.loadMore();
                }else{
                    this.toggleFooterVisibility(e.target)
                }
            })

            self.routerTo = this.$store.state.customer.routerTo;
        },

        data() {
            return{
                
            }
        },

        computed: {
            ...mapGetters('customer', ['notification']),
        },

        methods: {
            ...mapActions('customer', [
                'launchNotification',
                'getNotificationList',
                'loadNotification',
                'setNotifShowLoadingBar',
            ]),

            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },

            loadMore(){
                console.log("LOAD MORE GET CALLED");

                const self = this;

                if (!self.notification.allowInfinite){
                    return;
                }
                self.notification.allowInfinite = false;

                setTimeout(function () {

                    // console.log(self.lastItem);

                    self.getNotificationList(self.notification.lastItem+1, self.notification.itemPerPage, self.notification.isRead).then(()=>{

                        self.loadNotification();

                    });

                }, 5000);
            },

            readInbox(item){

                console.log("MESSAGE", item)

                var message = this.$store.state.misc.message;

                message.id               = item.id
                message.title            = item.title
                message.subject          = item.subject
                message.date             = item.date
                message.content          = item.content
                message.read             = item.read
                this.$f7router.navigate("/notification/detail");
            },

            goHome(){
				this.$f7router.navigate("/home", { transition: 'f7-fade', clearPreviousHistory  : true });

            },

            backButton() {

                this.$f7router.back({ transition: 'f7-push' });

            },

            handleBeforeOut(){
                this.loadingFirstItem = true
                this.isRead = 0
            }
        }

    }
</script>
